/*******************************************************************************
  설  명 : 홈페이지 > 이메일주소 수신거부
  작성자 : 송영석
  작성일 : 2020-07-22
*******************************************************************************/
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

import { CommonService } from '@app/service/common.service';
import { UtilService } from '@app/service/util.service';
import { NewsletterService } from '@home/service/newsletter.service';

import { O2OZCMS } from '@app/components/o2oz-cms/o2oz-cms.component';

@Component({
  selector: 'app-unsubscribe',
  templateUrl: './unsubscribe.component.html',
  styleUrls: ['./unsubscribe.component.scss']
})
export class UnsubscribeComponent extends O2OZCMS implements OnInit {

  /*******************************************************************************
    설명 : 전역 변수 선언부
  *******************************************************************************/
  public form: FormGroup;
  public formErrors = {};

  /*******************************************************************************
    설  명 : 빌드폼 생성
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  buildForm(): void {
    this.form = this.formBuilder.group({
      email: [ '', [Validators.required, Validators.email] ],
    });

    this.form.valueChanges.subscribe(data => {
      this.utilService.updateFormErrors( this.form, this.formErrors );
    });
  }

  /*******************************************************************************
    설  명 : 생성자
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  constructor(
    router: Router,
    commonService: CommonService,
    activatedRoute: ActivatedRoute,
    toastrService: ToastrService,
    private newsletterService: NewsletterService,
    private utilService: UtilService,
    private formBuilder: FormBuilder,
  ) {
    // 상위 클래스에 router 전달
    super(router, commonService, activatedRoute, toastrService);

    this.buildForm();
  }

  /*******************************************************************************
    설  명 : 데이터 초기화
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  ngOnInit(): void {
  }

  /*******************************************************************************
    설  명 : 이메일 수신 거부 처리
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  setUnsubscribe() {
    this.utilService.makeFormDirtyAndUpdateErrors(this.form, this.formErrors);

    if ( this.form.valid ) {
      this.newsletterService.setUnsubscribe( this.form ).then(response => {
        if ( response.ResultCode == true ) {
          this.toastrService.success(response.ResultMessage, '이메일 수신거부');

          this.router.navigate(['/main']);

        } else {
          this.toastrService.error(response.ResultMessage, '이메일 수신거부');
        }
      });

    } else {
      this.toastrService.error( this.formErrors['email'], '이메일 수신거부');
    }
  }

}
